<template>
  <div class="lg:mr-44">
    <div
      class="bg-black p-6 py-12 lg:py-6 flex text-white lg:flex-nowrap flex-wrap space-y-6 lg:space-y-0"
      :class="client === 'client2tenant' ? 'lg:ml-56' : ''"
    >
      <div
        class="w-full lg:w-3/12 flex lg:flex-nowrap flex-wrap space-y-4 lg:space-y-0 lg:justify-start items-center justify-center"
      >
        <div class="w-32 flex items-center justify-center">
          <img src="/img/expo_symbol_white.png" alt="expo logo symbol" />
        </div>
        <!--
          <div class="w-full self-center lg:ml-12 lg:justify-start justify-center flex items-center">
          <button @click="subscribe" class="btn bg-expo_red h-14 m-0 my-8 lg:my-0 font-poppins font-regular">Subscribe</button>
          </div> 
        -->
      </div>
      <div
        class="w-full lg:w-9/12 px-4 flex flex-wrap lg:flex-nowrap justify-between lg:space-x-4 space-y-6 lg:space-y-0"
      >
        <div
          class="w-full lg:w-auto lg:flex lg:space-x-2 space-y-4 lg:space-y-0"
        >
          <h5
            class="font-poppins font-semibold text-white relative bottom-1 lg:text-left text-center"
          >
            Explore
          </h5>
          <div class="text-white cursor-pointer lg:text-left text-center">
            <p
              class="hover:text-expo_red"
              @click="handleMenuClick('ForExhibitors')"
            >
              For Exhibitors
            </p>
            <p class="hover:text-expo_red" @click="handleMenuClick('Schools')">
              For Schools
            </p>
            <a
              :href="settings.cloud_url"
              class="no-underline font-normal text-sm hover:text-expo_red"
              >Online Expo</a
            >
          </div>
          <h5
            v-if="events.length > 0"
            class="lg:hidden font-poppins font-semibold text-white relative bottom-1 lg:text-left text-center"
          >
            Upcoming Expos
          </h5>
          <div
            v-if="events.length > 0"
            class="text-white cursor-pointer lg:text-left text-center"
          >
            <div v-for="(item, i) in events" :key="i" class="">
              <p
                v-if="client === 'client2'"
                class="hover:text-expo_red cursor-pointer"
                @click="goToEvent(item.slug)"
              >
                {{ item.title }}
              </p>
              <a
                v-else
                class="no-underline font-normal text-sm hover:text-expo_red"
                :href="settings.central_domain2_url + '/event/' + item.slug"
                >{{ item.title }}</a
              >
            </div>
          </div>
        </div>

        <div
          class="w-full lg:w-auto lg:flex lg:space-x-2 space-y-4 lg:space-y-0"
        >
          <h5
            class="font-poppins font-semibold text-white relative bottom-1 lg:text-left text-center"
          >
            Contact
          </h5>
          <div class="text-white lg:text-left text-center">
            <div>
              <a
                class="font-normal cursor-pointer no-underline hover:text-expo_red"
                target="_blank"
                href="tel:0274949316"
                >027 494 9316</a
              >
            </div>
            <div>
              <a
                class="font-normal cursor-pointer no-underline hover:text-expo_red"
                target="_blank"
                href="mailto:mark@careersexpo.org.nz"
                >mark@careersexpo.org.nz</a
              >
            </div>
            <p>PO Box 612, Whangaparaoa</p>
            <p>Auckland 0932</p>

            <div
              class="flex space-x-4 mt-4 lg:items-start lg:justify-start items-center justify-center"
            >
              <a
                class="font-normal cursor-pointer no-underline hover:text-expo_red"
                target="_blank"
                href="tel:0274949316"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                  />
                </svg>
              </a>
              <a
                class="font-normal cursor-pointer no-underline hover:text-expo_red"
                target="_blank"
                href="mailto:mark@careersexpo.org.nz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                  />
                  <path
                    d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div
          class="w-full lg:w-auto lg:flex lg:space-x-2 space-y-4 lg:space-y-0"
        >
          <h5
            class="font-poppins font-semibold text-white relative bottom-1 lg:text-left text-center"
          >
            Follow
          </h5>
          <div class="text-white lg:text-left text-center">
            <a
              class="font-normal cursor-pointer no-underline hover:text-expo_red"
              href="/account"
              >Admin Login</a
            >
            <p
              class="hover:text-expo_red cursor-pointer"
              @click="handleMenuClick('privacy')"
            >
              Privacy Policy
            </p>
            <p
              class="hover:text-expo_red cursor-pointer"
              @click="handleMenuClick('terms')"
            >
              Terms & Conditions
            </p>
            <div
              class="flex space-x-4 mt-4 lg:items-start lg:justify-start items-center justify-center"
            >
              <a
                class="font-normal cursor-pointer no-underline hover:text-expo_red"
                target="_blank"
                href="https://www.facebook.com/thecareersexpo/"
              >
                <svg
                  fill="currentColor"
                  class="cursor-pointer hover:text-expo_red h-4 w-4"
                  role="img"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Facebook</title>
                  <path
                    d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                  />
                </svg>
              </a>
              <a
                class="font-normal cursor-pointer no-underline hover:text-expo_red"
                target="_blank"
                href="https://www.linkedin.com/company/nz-careers-expo"
              >
                <svg
                  fill="currentColor"
                  class="cursor-pointer hover:text-expo_red h-4 w-4"
                  role="img"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>LinkedIn</title>
                  <path
                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="lg:h-8 font-normal bg-black text-truegray-500 flex items-center justify-end px-10 lg:py-0 py-10 lg:text-left text-center"
    >
      <p>
        © {{ year }} New Zealand Careers Expo. Created in Partnership with
        <a
          href="https://hail.to"
          target="_blank"
          class="font-normal cursor-pointer no-underline hover:text-expo_red text-truegray-500"
          >Hail</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      year: null,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
      events: 'expo/getEvents',
    }),
  },

  async mounted() {
    if (this.events.length < 1) {
      await this.dispatchSetEvents()
    }

    const d = new Date()
    let year = d.getFullYear()
    this.$set(this, 'year', year)
  },

  methods: {
    ...mapActions({
      dispatchSetEvents: 'expo/dispatchSetEvents',
    }),

    goToEvent(slug) {
      // Be wary of pushing to the same template
      // If on the event template already we need to replace
      // If not on the event template we can push
      if (this.$router.history.current.name === 'Event') {
        this.$router.replace({ path: '/event/' + slug, params: { slug: slug } })
      } else {
        this.$router.push({ path: '/event/' + slug })
      }
    },

    handleMenuClick(request) {
      if (request === 'privacy') {
        EventBus.$emit('showModal', 'expo-privacy')
      } else if (request === 'terms') {
        EventBus.$emit('showModal', 'exhibitor-terms')
      } else {
        this.$router.push({ name: request })
      }
    },
  },
}
</script>
